import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const F = ({ label, testId, ...p }) => (
  <label className="block text-xs text-[#7C7064]">{label}
    <input data-testid={testId} {...p} className="mt-1 w-full px-3 py-2 bg-white border border-[#E8DCC8] text-sm text-[#2C2621]"/>
  </label>
);

export function ClientInfoForm({ client, onDone, onCancel }) {
  const mc = client.mailclub.find(m => m.email === client.email) || {};
  const parts = (client.name || "").split(" ");
  const a = client.address || {};
  const [f, setF] = useState({
    first_name: mc.first_name || parts[0] || "", last_name: mc.last_name || parts.slice(1).join(" ") || "",
    line1: a.line1 || "", line2: a.line2 || "", postal_code: a.postal_code || "", city: a.city || "", country: a.country || "FR",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try {
      const { first_name, last_name, ...address } = f;
      const r = await api.put(`/admin/clients/${encodeURIComponent(client.email)}/info`, { first_name, last_name, address });
      const n = Object.values(r.data.updated).reduce((x, y) => x + y, 0);
      toast.success(`Infos enregistrées · ${n} fiche(s) mise(s) à jour`);
      onDone();
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur"); } finally { setSaving(false); }
  }

  return (
    <form data-testid="client-info-form" onSubmit={save} className="bg-[#F5F0E6] border border-[#E8DCC8] p-5 mb-8 grid sm:grid-cols-2 gap-3 max-w-2xl">
      <F label="Prénom" testId="client-info-first" value={f.first_name} onChange={set("first_name")}/>
      <F label="Nom" testId="client-info-last" value={f.last_name} onChange={set("last_name")}/>
      <div className="sm:col-span-2"><F label="Adresse" testId="client-info-line1" value={f.line1} onChange={set("line1")}/></div>
      <div className="sm:col-span-2"><F label="Complément" testId="client-info-line2" value={f.line2} onChange={set("line2")}/></div>
      <F label="Code postal" testId="client-info-postal" value={f.postal_code} onChange={set("postal_code")}/>
      <F label="Ville" testId="client-info-city" value={f.city} onChange={set("city")}/>
      <F label="Pays (code, ex. FR)" testId="client-info-country" value={f.country} onChange={set("country")} maxLength={2}/>
      <p className="sm:col-span-2 text-[11px] text-[#7C7064]">Met à jour les fiches Club de Lettres et les adresses d'expédition des commandes / correspondances. L'email se corrige via « Corriger l'email ».</p>
      <div className="sm:col-span-2 flex gap-3">
        <button data-testid="client-info-save" disabled={saving} className="btn-primary !py-2">{saving ? "…" : "Enregistrer"}</button>
        <button type="button" onClick={onCancel} className="btn-outline !py-2">Annuler</button>
      </div>
    </form>
  );
}
